import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  fieldsContainer: {
    'display': 'flex',
    // 'alignItems': 'flex-end',
    'gap': '15px',
    'padding': '15px',
    'height': 'calc(100% - 30px)',
    '@media screen and (max-width: 760px)': {
      flexDirection: 'column',
      overflowY: 'auto'
    },
    '&::-webkit-scrollbar': {
      width: '6px',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '3px',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'darkgrey',
      borderRadius: '3px',
    },
  },
  leftContainer: {
    'width': '30%',
    '@media screen and (max-width: 760px)': {
      width: '100%'
    }
  },
  rightContainer: {
    'display': 'flex',
    'flexDirection': 'column',
    'height': '100%',
    // 'grid-template-columns': '99%',
    // 'grid-template-rows': '100%',
    'width': '70%',
    '@media screen and (max-width: 760px)': {
      width: '100%',
      height: 'unset',
      display: 'block'
    }
  },
  paper: {
    padding: '15px',
    marginBottom: 16,
  },
  paperLeft: {
    padding: '15px 15px 0 15px',
    height: 'auto',
  },
  fieldsLeftContainer: {
    'padding': '15px',
    'padding-top': '5px',
    'height': 'calc(100% - 140px)',
    'position': 'relative'
  },
  paperLeftContainer: {
    'padding-bottom': '15px',
    'height': 'calc(100% - 15px)',
    'display': 'flex',
    'flex-direction': 'column',
    'gap': '0',
  },
  actionBtn: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
  containerLabel: {
    fontSize: 14,
    fontWeight: 200,
    color: '#777777',
    height: 25
  },
  widgetTitleTextField: {
    '& .MuiInputLabel-root': {
      fontSize: 14,
    }
  },
  fieldContainerLabel: {
    fontSize: 14,
    fontWeight: 200,
    color: '#777777',
    height: 25,
    position: 'absolute',
    zIndex: 1,
    top: 25
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'right',
    columnGap: 15,
    height: '10%',
    padding: '0 15px'
  },
  outputFieldsContainer: {
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
    // minHeight: '275px',
  },
  action: {
    'background': '#F5F5F5',
    'max-height': '40px',
    'color': 'black',
    'borderRadius': '4px',
    'textTransform': 'none',
    'padding': '8px 16px',
    'width': '100%',
    '&:focus': {
      background: '#F47920',
      border: '1px solid #F47920',
      color: 'white'
    },
    '@media screen and (max-width: 1100px), (max-height: 1000px)': {
      width: '150px',
    }
  },
  active: {
    'max-height': '40px',
    'background': '#F47920',
    'color': 'white',
    'borderRadius': '4px',
    'textTransform': 'none',
    'padding': '8px 16px',
    'width': '100%',
    '&:hover': {
      background: '#F47920',
    },
    '@media screen and (max-width: 1100px), (max-height: 1000px)': {
      width: '150px',
    }
  },
});
